import type {ListLeadsSearchInput} from "./list-leads.schema";

import {keepPreviousData, useQuery} from "@tanstack/react-query";

import {listLeadsQueryOptions} from "./list-leads.query-options";

export function useListLeads(rawInput: ListLeadsSearchInput) {
  return useQuery({
    ...listLeadsQueryOptions(rawInput),
    placeholderData: keepPreviousData,
  });
}
